import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc2c2e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = {
  key: 1,
  class: "form-group w-100"
}
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "legend form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_field, {
              type: "select-string",
              needSorting: false,
              list: _ctx.destinations,
              modelValue: _ctx.spendingEmissionData.destination,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spendingEmissionData.destination) = $event)),
              labelKey: "Allocation",
              labelValue: "Allocation",
              placeholderKey: "Select an allocation",
              placeholderValue: "Select an allocation",
              class: "mb-3"
            }, null, 8, ["list", "modelValue"])
          ])
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.timeFrameList,
              modelValue: _ctx.timeFrameSelected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeFrameSelected) = $event)),
              labelKey: "Time frame",
              labelValue: "Time frame",
              placeholderKey: "Select a time frame",
              placeholderValue: "Select a time frame"
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.availableYears,
              modelValue: _ctx.selectedYear,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedYear) = $event)),
              labelKey: "Year",
              labelValue: "Year",
              placeholderKey: "Select a year",
              placeholderValue: "Select a year",
              onChange: _ctx.yearUpdated
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          (_ctx.timeFrameSelected == _ctx.viewModel.TimeFrame.Month)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_form_field, {
                  type: "select",
                  list: _ctx.monthList,
                  modelValue: _ctx.saveModel.month,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saveModel.month) = $event)),
                  labelKey: "Month",
                  labelValue: "Month",
                  placeholderKey: "Month",
                  placeholderValue: "Month"
                }, null, 8, ["list", "modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.premises.length > 0)
              ? (_openBlock(), _createBlock(_component_form_field, {
                  key: 0,
                  type: "select",
                  list: _ctx.premises,
                  modelValue: _ctx.saveModel.selectedPremises.identifier,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saveModel.selectedPremises.identifier) = $event)),
                  labelKey: "Premises type",
                  labelValue: "Premises type",
                  placeholderKey: "Select a premises type",
                  placeholderValue: "Select a premises type"
                }, null, 8, ["list", "modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Premises type",
                    text: "Premises type",
                    class: "input_title d-block fw_700 mb-2"
                  }),
                  (_ctx.premises.length == 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addPremises()))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Add new premises",
                          text: "Add new premises"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.categories,
              modelValue: _ctx.spendingEmissionData.category,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.spendingEmissionData.category) = $event)),
              labelKey: "Category",
              labelValue: "Category",
              placeholderKey: "Select a category",
              placeholderValue: "Select a category",
              onChange: _ctx.categoryUpdated
            }, null, 8, ["list", "modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.subCategories,
              modelValue: _ctx.spendingEmissionData.subCategory,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.spendingEmissionData.subCategory) = $event)),
              labelKey: "Sub Category",
              labelValue: "Sub Category",
              placeholderKey: "Select a sub category",
              placeholderValue: "Select a sub category",
              onChange: _ctx.subCategoryUpdated
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.elementNames,
              modelValue: _ctx.spendingEmissionData.elementName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.spendingEmissionData.elementName) = $event)),
              labelKey: "Element Name",
              labelValue: "Element Name",
              placeholderKey: "Select an element name",
              placeholderValue: "Select an element name"
            }, null, 8, ["list", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_form_field, {
              type: "number",
              step: 0.1,
              modelValue: _ctx.saveModel.consumption,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.saveModel.consumption) = $event)),
              labelKey: "Consumption (USD)",
              labelValue: "Consumption (USD)",
              placeholderKey: "Consumption (USD)",
              placeholderValue: "Consumption (USD)"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-tertiary px-5",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calculateAndSave())),
            disabled: _ctx.calculateDisabled
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Calculate & Record",
              text: "Calculate & Record"
            })
          ], 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_localized_text, {
            localizedKey: "Attention",
            text: "Attention",
            class: "input_title",
            type: "label"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "Spending must be indicated in USD: remember to exchange your original currency as per your accounting rules",
            text: "Spending must be indicated in USD: remember to exchange your original currency as per your accounting rules",
            class: "mb-0",
            type: "p"
          })
        ])
      ]))
    : _createCommentVNode("", true)
}